<template>
  <div class="smartPublicSecurity-layout">

    <!-- <swiper class="swiper" :options="swiperOptions" ref="mySwiper" v-if="pageDataList.length > 0"> -->
    <swiper-slide class="swiper-slideInn">

      <!-- </swiper-slide> -->
      <!-- <swiper-slide class="swiper-slideInn"> -->
      <!-- top样式-->
      <div class="swiper-s" v-if="isTestModel">
        <div class="swiper-wrapper">
          <div class="swiper-slide" @click="openwindow">
            <div>
              <div style="left:14vw;top:16vh;position: absolute;">
                <span class="titlefont">{{ pageData.bannerTitle }}</span><br /><br />
                <el-button class="sendStyle">申请试用</el-button>
              </div>
              <img style="width: 100%;height:40vh;display: block;" src="@/assets/img/cpfaheader.png" alt="">
            </div>
          </div>
          <div class="swiper-slide">
            <div class="top-layout"
              :style="'position: absolute;background:url(' + pageData.bannerUrl + ');background-size: 100% 100%;background-repeat: no-repeat;'">
              <!-- <borderUpdateCom btnText="banner编辑" class="topbanner" componentsName="BannerEdit">
            <div class="bannerchange">
            </div>
          </borderUpdateCom> -->
              <img src="@/assets/img/childrenpage/smartPublicSecurity/moban1.svg" class="moban1" />
              <div class="moban2">
                <borderUpdateCom btnText="主标题编辑" componentsName="IndexEdit" :pageObj="pageObj">
                  <div class="title">{{ pageData.bannerTitle }}</div>
                </borderUpdateCom>
                <div class="sban-list">{{ orname }}>{{ scname }}>{{ pageObj.name }}</div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div v-show="!isTestModel" class="top-layout"
        :style="'background:url(' + pageData.bannerUrl + ');background-size: 100% 100%;background-repeat: no-repeat;'">
        <!-- <borderUpdateCom btnText="banner编辑" class="topbanner" componentsName="BannerEdit">
            <div class="bannerchange">
            </div>
          </borderUpdateCom> -->
        <img src="@/assets/img/childrenpage/smartPublicSecurity/moban1.svg" class="moban1" />
        <div class="moban2">
          <borderUpdateCom btnText="主标题编辑" componentsName="IndexEdit" :pageObj="pageObj">
            <div class="title">{{ pageData.bannerTitle }}</div>
          </borderUpdateCom>
          <div class="sban-list">{{ orname }}>{{ scname }}>{{ pageObj.name }}</div>
        </div>
      </div>
      <!-- 服务简介-->
      <div class="content">
        <!-- <borderUpdateCom btnText="标题编辑" componentsName="TitleEdit"> -->
        <el-button type="primary" v-if="$store.state.editStatus === 0" @click="addTestBtn(true)">添加试用</el-button>
        <el-button type="primary" v-if="$store.state.editStatus === 0" @click="addTestBtn(false)">删除试用</el-button>

        <!-- </borderUpdateCom> -->
        <borderUpdateCom btnText="标题编辑" componentsName="TitleEdit">
          <TitleCom :text="pageDataList[0].name" />
        </borderUpdateCom>
        <div class="content-layout">
          <borderUpdateCom btnText="内容编辑" componentsName="ContentEdit">
            <div class="html-content swiper-no-swiping" v-html="pageDataList[0].content">
            </div>
          </borderUpdateCom>
          <borderUpdateCom btnText="图片编辑" componentsName="ImageEdit">
            <img :src="pageDataList[0].imgUrl" class="sevice-img" />
          </borderUpdateCom>
        </div>
      </div>
    </swiper-slide>

    <!-- 痛点分析-->
    <swiper-slide class="swiper-slideInn"
      v-show="pageDataList[1].moduleList.length > 0 || $store.state.editStatus === 0">
      <div class="painpoint">
        <borderUpdateCom btnText="编辑数量" componentsName="PainSpotAdd">
          <div class="painpoint-content">
            <borderUpdateCom btnText="标题编辑" componentsName="TitleEditTd">
              <TitleCom :text="pageDataList[1].name" class="titlePosition" />
            </borderUpdateCom>
            <div class="painpoint-list">
              <div v-for="(i, index) in pageDataList[1].moduleList" :key="index">
                <borderUpdateCom :btnText="'编辑' + pageDataList[1].name" :indexs="index" :nowNumber="1"
                  componentsName="PainSpotEdit">
                  <!-- <div class="painpoint-item"
                      :class="pageDataList[1].moduleList.length == 1 ? 'sizewidth' : pageDataList[1].moduleList.length == 2 || pageDataList[1].moduleList.length == 4 ? 'sizewidthdb' : ''"> -->
                  <div class="painpoint-item" :class="PgetainpointClass(pageDataList[1].moduleList.length)">
                    <div class="iconlogo">
                      <img
                        :src="i.imgUrl == baseImg ? require('@/assets/img/childrenpage/smartPublicSecurity/tdbase.png') : i.imgUrl"
                        class="neicon" />
                    </div>
                    <div class="painpoint-title">{{ i.chtitle }}</div>
                    <div class="painpoint-text">{{ i.content }}</div>
                  </div>
                </borderUpdateCom>
              </div>
            </div>
          </div>
        </borderUpdateCom>
      </div>
    </swiper-slide>
    <!-- 核心价值-->
    <swiper-slide class="swiper-slideInn"
      v-show="pageDataList[2].moduleList.length > 0 || $store.state.editStatus === 0">
      <div class="coreValues">
        <div class="coreValues-content">
          <borderUpdateCom btnText="标题编辑" componentsName="TitleEditValue">
            <TitleCom :text="pageDataList[2].name" />
          </borderUpdateCom>
          <borderUpdateCom btnText="编辑数量" componentsName="CoreValuesAdd">
            <div class="coreValues-list">
              <div v-for="(i, index) in pageDataList[2].moduleList" :key="index">
                <borderUpdateCom btnText="编辑" :indexs="index" :nowNumber="2" componentsName="CoreValuesEdit">
                  <div class="coreValues-item" :class="getValuesClass(pageDataList[2].moduleList.length)">
                    <img :src="i.imgUrl" class="itemicon" />
                    <div class="coreValues-right">
                      <div class="coreValues-title">{{ i.chtitle }}</div>
                      <div class="coreValues-text">{{ i.content }}</div>
                    </div>
                  </div>
                </borderUpdateCom>
              </div>
            </div>
          </borderUpdateCom>
        </div>
      </div>
    </swiper-slide>
    <!-- 特色应用-->
    <swiper-slide class="swiper-slideInn"
      v-show="pageDataList[3].moduleList.length > 0 || $store.state.editStatus === 0">
      <div class="featureapplication">
        <div class="featureapplication-content">
          <borderUpdateCom btnText="标题编辑" componentsName="TitleEditApp">
            <TitleCom :text="pageDataList[3].name" />
          </borderUpdateCom>
          <borderUpdateCom btnText="编辑数量" componentsName="featureApplicationAdd">
            <div class="featureapplication-list">
              <div v-for="(i, index) in pageDataList[3].moduleList" :key="index">
                <borderUpdateCom btnText="编辑" :indexs="index" :nowNumber="3" componentsName="featureApplicationEdit">
                  <div class="featureapplication-item" :class="getAppClass(pageDataList[3].moduleList.length)">
                    <div class="featureapplication-right">
                      <img :src="i.imgUrl" class="itemicon" />
                      <div class="featureapplication-title">{{ i.chtitle }}</div>
                      <div class="featureapplication-text">{{ i.content }}</div>
                    </div>
                  </div>
                </borderUpdateCom>
              </div>
            </div>
          </borderUpdateCom>
        </div>
      </div>
    </swiper-slide>
    <!-- </swiper> -->
    <el-dialog title="产品申请试用" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
      <el-form :model="ruleForm" :rules="rules" ref="addForm" label-width="130px" class="demo-ruleForm">
        <el-form-item label="产品名称：">
          <span style="font-weight: bold; color: #333;">{{ ruleForm.product }}</span>
        </el-form-item>
        <el-form-item label="联系人：" prop="name">
          <el-input v-model="ruleForm.name" :maxLength="11" style="width: 95%"></el-input>
        </el-form-item>
        <el-form-item label="联系手机：" prop="phone">
          <el-input v-model="ruleForm.phone" style="width: 95%">
            <template slot="append" @click="">
              <div @click="sendMsgCode(ruleForm.phone)"> 验证码<span v-if="downTime !== 0">{{ downTime }}</span>
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input v-model="ruleForm.code" style="width: 95%"></el-input>
        </el-form-item>
        <el-form-item label="单位名称：" prop="company">
          <el-input v-model="ruleForm.company" style="width: 95%"></el-input>
        </el-form-item>
        <el-form-item label="职务：" prop="duties">
          <el-input v-model="ruleForm.duties" style="width: 95%"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('addForm')">提交申请</el-button>
          <el-button @click="dialogVisible = false">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="提示信息" :visible.sync="dialogVisible1" width="20%" :close-on-click-modal="false"
      :show-close="false">
      <span class="subForm">{{ dialogVisibleMsg }}</span>
    </el-dialog>
  </div>
</template>

<script>
import TitleCom from './components/titleCom.vue';
import borderUpdateCom from './components/borderUpdateCom.vue';
import { getProgrammeCustom, addProgrammeCustom, getProgrammeCustomExist } from "@/api/pageTemplate.js";
import { baseJSON } from './base';
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { addProductUse, sendMsgCode } from "@/api/solutio.js"
import { addProgrammeCustomDetail } from "@/api/pageTemplate.js";
import Swiper from 'swiper';
export default {
  name: 'smartPublicSecurity',
  components: {
    TitleCom,
    swiperSlide,
    swiper,
    borderUpdateCom,
  },
  data() {
    let that = this

    return {
      dialogVisible1: false,
      dialogVisibleMsg: '',
      rules: {
        name: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系人电话', trigger: 'blur' },
          { min: 11, max: 11, message: '长度在 11 个字符', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请输入联系人单位名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        duties: [
          { required: true, message: '请输入你的职务', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入你的验证码', trigger: 'blur' },
          { min: 6, max: 6, message: '长度在6个字符', trigger: 'blur' }
        ],

      },
      dialogVisible: false,
      ruleForm: {},
      baseImg: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAABACAYAAABC6cT1AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAVZSURBVGhD7Zv9bxRFGMfvD1JjosbE4EuIP0BiTMQYftBEif5iYmKICmpERSOCGHyJVaOhGEUQFapREpJiFMWmSAiCWoUCba8gL22F9K5Xjmv7uN/rTfvs7MzNy+5cD9dv8m0DO7vzfDr7Ms8zuwXKqf4Hz5uCgw+NEPUcI/rqINHH+4je7ybq2DP7G//G/2M72rVSmYP39hO9uZvowQ6iG58muuYJe6M99sP+OE5IZQLed5ro1S6i219QA/kax8NxcfyslQr8QDQqj21WB5210Q/6y0pe4MNjRKu2qgMMbfSL/tPKGXzbfqLrV6mDapXRP+JII2vwy1cWbpR1RjyIy0dW4IMXiO7bpO58oY24Bs43AnWQEfzoENHil9SdtosRH+J0UVNwHGzRGnVn7WbE6QKvBcfp0+4jLRvx2p72SnDcMNr1mjYZcVdrDZAmUoK3293b1YjfpAQ4no/ygW55boa2/zhJZ0dKND4+bvSRk2Xa2TNJK7fU6OZnZ2hFR41e66rS0NnZ/YvnSrTnUIXW76rSDatnEv1lYdNzPgY+PKqenHy+fzIBZ+vvj0xEN55ZOPwRvvmlEtveP1yi5W9MJfpMa3CAR6cYuO4UPz9qN9I6HyuWafHa+ZHt3Hs50eaR92qxPrPw6k8bYArNgSMBUO0My0H6uG+wHGVb8/AffRc/i8YuhoHXJTZz4M2yLB6g8O6DFXq8s0Zrtl+hQ8fLyjay/5DgO/cmL6Gs4cGlUh28b1i9k7AcHG5cfPt1TxEd7reDN438yD/j9NA72V7z4JNVB0eyr9pBmAcGP/B2MrC1O6qJdjrL8Nv2hYUHn6w6+B0vqncQ5kHB97+VDhzm8Nc+GRYefLIKqG2pGnPzgOAvoscb3+5yqnO3El6u4RVQ2FM15ObBCPvc3FT+fSB+2n/yQ/KGlwU8OLkKqGqqGnLLgWRtjPyi58OOPDi5CjYlYB5EKP92qky3NuDhrdLIj4ylg7/pmQZxQwVVI9nFxhw7tAFvGnnVjdXWRTaFtQLvPhyfX4e0Gb7kDY8VGyErcNzAeOehfTTK7gQ8vOOn5GmvmkuYjOUqIStwGFkU7zy0ZfjPorSYb/cZeazVCVmDL31lmgb/bi088noOL6fHGHkXeCxUClmDw0vXTdeLCLzz0P71RDkWw7dSPg/4ZRunY210xiqtkBM4fNf61sOv21md6x+THXk7ih08Rp29R1z47g3TdOZC6+B39VRi/Z88He/73Ggptl1nr2tc9j3R6WVbg0vrrEbc666u8r2vTwWHt7nGMQi8jc7Oz/FmXrZxKnVNTmd5MvPlz+lmcrGZG+awqkYuXr5pqv5c5UGlddaJS2KubpOd2Rh/+azgQ+TpiezMJh+39Sx8HMLVx4vNoVGN9cnSEvm4TQXGxQjKFx7QvP6ugvatwiYqMPhhqrm5GvAIkgdtsgwtV18vXvKHVtbc8MNUZfUxgkSwPHidT0QTEhP0ox/419u1VVZTXd3XCNYED+g7X55/DmcNDWvr6lCo99UQ9CUN/ECU7XHoD7vja2rYLy1005UUqNnaWVpjuZgDwafOlGhJlOqKNhu6knV5VHH5cXxsXDuDsLqo2jkLP/xujQ78NVFPKL7urcRGGr4teoT1/jlRB+7pm6AVHe6PLNlWq6WQbn38arTT+jikeiPiarTTGxFCuXwHBsJbQ7l86wnK5XtuQrl8s1EIB2v3kUd8LtCQERzC6dOu1zzisj29uazAoVy+r86F5+NCT3LQv+k5bZIzOJTLb1K4kACEyupkox9dwuGjVOBCufvuTCXUtlDYQ1XzP/+lYTOpvi0F5MJ+W0r0L9m9Vfq7xsa5AAAAAElFTkSuQmCC',
      orname: '',// 父级name
      scname: '',// 第二级name
      pageObj: {},// 上一页传过来的数据
      pageData: {},// 当前页面数据
      pageDataList: [],//当前也数据列表
      isTestModel: false,//是否拥有试用按钮
      saveData: {},
      downTime: 0,
      swiperOptions: {
        speed: 800,
        // grabCursor: true,
        direction: "vertical",
        slidesPerView: "auto",
        mousewheel: {},
        pagination: {
          el: ".swiper-pagination.page",
          clickable: true,
        },

        on: {
          init: function () {
            that.$swiperAnimateCache(this); //隐藏动画元素
            that.$swiperAnimate(this); //初始化完成开始动画
          },
          slideChangeTransitionStart: function () {

            that.$swiperAnimate(this); //每个slide开始切换时也运行当前slide动画
            //this.slides.eq(this.activeIndex).find('.ani').removeClass('ani'); 动画只展现一次，去除ani类名
          },
          slideChange: () => {
          }
        },
      },
    }
  },
  watch: {
    '$store.state.changeRefresh'() {
      this.getData()
    },
    '$route.query.data': {

      handler: function (val) {
        this.ruleForm.product = this.pageData.bannerTitle;
        this.orname = this.$route.query.orname;
        this.scname = this.$route.query.scname;
        this.pageObj = JSON.parse(this.$route.query.data);
        this.getData()
      },
      deep: true

    },
    'pageDataList[1].moduleList': {
      handler: function (newVal, oldVal) {
        if (newVal.length == 2) {
          // 更新painpoint-list的flex样式
          this.updateFlexStyle(2);
        }
      },
      deep: true
    }

  },
  mounted() {
    this.ruleForm.product = this.pageData.bannerTitle;

    this.orname = this.$route.query.orname;
    this.scname = this.$route.query.scname;

    this.pageObj = JSON.parse(this.$route.query.data);
    getProgrammeCustomExist({
      isRelease: this.$store.state.editStatus,
      proProgrammeId: this.pageObj.id
    }).then(res => {
      if (res.data) {
        this.getData();
      } else {
        this.saveBaseData();
      }


    })

  },
  methods: {
    openwindow() {
      // debugger
      this.dialogVisible = true
    },
    addTestBtn(isTest) {
      let testContent = JSON.parse(this.saveData.content)
      testContent.isTest = isTest
      this.saveData.content = JSON.stringify(testContent)
      addProgrammeCustomDetail(this.saveData).then(res => {
        if (res.data == 1) {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.getData()
        } else {
          this.$message({
            message: res.msg,
            type: 'success'
          });
        }

      })
    },
    submitForm(ref) {
      this.$refs[ref].validate((valid) => {
        if (valid) {
          addProductUse(this.ruleForm).then(res => {
            if (res.code === 200) {
              if (this.pageObj.name = "管线三维建模工具") {
                window.open('https://pdl.dpark.com.cn/pdl/pipe/Blue%20Pipe-v1.0.0-bate.exe')
              } else {
                this.$message.success('会有工作人员3-5个工作日联系您');
              }
              //    this.$message.success({
              //   message: '提交成功',
              //   duration: 10000, // 持续时间，单位为毫秒，默认为3000ms
              //   showClose: false, // 是否显示关闭按钮，默认为 true
              //   center: true // 将消息提示框放置在页面中间
              // });
              this.dialogVisible1 = true
              this.dialogVisibleMsg = '提交成功'
              setTimeout((res) => {
                this.dialogVisible1 = false

              }, 10000)
              // this.$message.success('提交成功');
              this.dialogVisible = false;
            } else {
              this.dialogVisibleMsg = res.msg
              // this.$message.error(res.msg);
            }

          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    //核心价值classs
    getValuesClass(size) {
      let classString = ''
      switch (size) {
        case 1:
          classString = 'valueModel1'
          break;
        case 2:
          classString = 'valueModel2'
          break;
        case 3:
          classString = 'valueModel3'
          break;
        case 4:
          classString = 'valueModel4'
          break;
        case 5:
          classString = 'valueModel5'
          break;
        case 6:
          classString = 'valueModel5'
          break;
      }
      return classString
    },

    //特色应用Class
    getAppClass(size) {
      let classString = ''
      switch (size) {
        case 1:
          classString = 'valueModel1'
          break;
        case 2:
          classString = 'valueModel2'
          break;
        case 3:
          classString = 'valueModel3'
          break;
        case 4:
          classString = 'valueModel4'
          break;
        case 5:
          classString = 'valueModel5'
          break;
        case 6:
          classString = 'valueModel5'
          break;
      }
      return classString
    },
    //痛点分析
    PgetainpointClass(size) {
      let classString = ''
      switch (size) {
        case 1:
          classString = 'valueModel1'
          break;
        case 2:
          classString = 'valueModel2'
          break;
        case 3:
          classString = 'valueModel3'
          break;
        case 4:
          classString = 'valueModel4'
          break;
        case 5:
          classString = 'valueModel5'
          break;
        case 6:
          classString = 'valueModel5'
          break;
      }
      return classString
    },
    getData() {
      getProgrammeCustom({
        isRelease: this.$store.state.editStatus,
        proProgrammeId: this.pageObj.id
      }).then(res => {
        this.$store.commit('saveProProgrammeId', this.pageObj.id)
        this.$store.commit('savePageTemplateData', JSON.parse(JSON.stringify(res.data)))
        this.pageData = res.data
        if (this.$store.state.pageTemplateData) {
          this.saveData = this.$store.state.pageTemplateData.customDetailList[0]
        }
        this.ruleForm.product = this.pageData.bannerTitle;
        this.pageDataList = this.pageData.customDetailList.map(item => {
          return {
            ...JSON.parse(item.content),
            name: item.name
          }
        })
        this.isTestModel = this.pageDataList[0].isTest
        this.$nextTick(() => {
          if (this.isTestModel) {
            var swiper = new Swiper('.swiper-s', {
              autoplay: 3000,
              speed: 1000,
              observer: true,
              observeParents: true,
              direction: 'horizontal', // 水平切换选项
              // loop: true, // 循环模式选项
              on: {

              }

            });
          } else {
            swiper.update()
          }

        })
        // if (res.code == 500000) {
        // this.saveBaseData()
        // }
      })
    },

    //保存初始数据
    saveBaseData() {

      let customDetailList = baseJSON.map((item, index) => {
        return {
          content: JSON.stringify(item),
          isRelease: 0,
          name: item.title,
          sort: index
        }
      })
      let param = {
        "bannerTitle": this.pageObj.name,
        "bannerUrl": require('@/assets/img/childrenpage/smartPublicSecurity/indexbg.jpg'),
        "customDetailList": customDetailList,
        "isRelease": 0,
        "proProgrammeId": this.pageObj.id,

      };
      addProgrammeCustom(param).then(res => {

        this.getData();
      })
    },
    sendMsgCode(tel = '') {
      tel = tel.replace(/(^\s*)/g, "");
      if (!tel.length == 11 || !tel) {
        this.$message.warning('请输入正确的手机号码');
        return
      }
      if (!this.downTime == 0) {
        this.$message.warning('请过一分钟后再试');
        return
      }
      sendMsgCode(tel).then(res => {
        this.$message.success('发送成功');
        this.downTime = 60;
        let stopTime = setInterval(e => {
          this.downTime--
          if (this.downTime == 0) {
            clearInterval(stopTime)
          }
        }, 1000)
      })
    }
  }
}

</script>
<style lang="scss" scoped>
.subForm {
  text-align: center;
  width: 100%;
  display: inline-block;
  margin: 0 auto;
}

.smartPublicSecurity-layout {
  // background: rgba(233, 235, 239, 1);
  width: 100%;
  height: 100%;

  // margin-top: 60px;
  .swiper {
    height: 100vh;
  }

  /* 顶部样式 */
  .top-layout {
    width: 100vw;
    height: 40vh;
    // background: url('../../../../assets/img/childrenpage/smartPublicSecurity/indexbg.jpg');
    display: flex;
    justify-content: center;
    position: relative;

    .moban1 {
      width: 100%;
      height: 100%;

      // margin-bottom: -20px;
    }

    .moban2 {
      background: url('../../../../assets/img/childrenpage/smartPublicSecurity/moban1.svg');
      background-size: 100% 100%;
      width: 100%;
      height: 166px;
      position: absolute;
      // z-index: 100;
      z-index: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .title {
        font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold',
          'PingFang SC ExtraLight', 'PingFang SC', sans-serif;
        font-weight: 650;
        font-style: normal;
        font-size: 38px;
        color: #ffffff;
      }

      .sban-list {
        font-family: 'PingFang-SC-ExtraLight', 'PingFang SC ExtraLight',
          'PingFang SC', sans-serif;
        font-weight: 400;
        font-style: normal;
        color: #ffffff;
        margin-top: 30px;
      }
    }
  }

  /* 服务简介 */
  .content {
    padding: 8vh 15vw 10vh 15vw;

    // background-image: url('../../../../assets/img/childrenpage/smartPublicSecurity/corebg.jpg');
    // background-size: 100% 100%;
    .content-layout {
      display: flex;
      justify-content: space-between;
      margin-top: 3vh;

      .html-content {
        width: 25vw;
        font-size: 14px;
        line-height: 30px;
      }

      .sevice-img {
        width: 32vw;
        height: 32vh;
      }
    }
  }

  /* 痛点分析 */
  .painpoint {
    width: 100%;
    height: 100vh;
    // background: rgba(233, 235, 239, 1);
    display: flex;
    background-image: url('../../../../assets/img/childrenpage/smartPublicSecurity/corebg.jpg');
    background-size: 100% 100%;
    justify-content: center;
    align-items: center;
    margin-top: 3vh;

    .painpoint-content {
      // margin: 0 auto;
      background: #ffffff60;
      width: 83vw;
      height: 72vh;
      padding: 5vh 2vw 5vh 2vw;

      // background-image: url('../../../../assets/img/childrenpage/smartPublicSecurity/corebg.jpg');
      // background-size: 100% 100%;
      // background-color: transparent;
      .titlePosition {
        // margin-left: 350px;
      }

      // .TitleEditTd {
      //   margin-top: -30px;
      // }
      .painpoint-list {
        width: 100%;
        // width: 1800px;
        // width: 100%;
        height: 72vh;

        // height: 650px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        // align-items: center;
        // margin-top: -5vh;
        margin-top: 30px;

        .valueModel1 {
          // width: 1303px !important;
          width: 903px !important;
          // height: 606px !important;
          height: 350px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .valueModel2 {
          // width: 1303px !important;
          width: 903px !important;
          height: 256px !important;
          display: flex;
          flex-direction: column;
          align-items: center;

          // padding-top: 10px;
          .painpoint-text {
            height: 120px !important;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
          }
        }

        .valueModel3 {
          width: 503px !important;
          // height: 206px !important;
          height: 306px !important;
          display: flex;
          flex-direction: column;
          align-items: center;

          // padding-top: 10px;
          .painpoint-text {
            height: 386px !important;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 13;
            overflow: hidden;
          }
        }

        .valueModel4 {
          width: 563px !important;
          // height: 206px !important;
          height: 286px !important;

          .painpoint-text {
            height: 120px !important;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
          }
        }

        .valueModel5 {
          width: 380px !important;
          height: 246px !important;

          .painpoint-text {
            height: 120px !important;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
          }
        }

        .painpoint-item {
          width: 328px;
          // max-height: 260px;
          // margin-top: 55px;
          margin-top: 2vh;
          margin-left: 50px;
          margin-right: 50px;

          // height: 206px;
          // width: 663px;
          // overflow: hidden;
          .painpoint-title {
            font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold',
              'PingFang SC ExtraLight', 'PingFang SC', sans-serif;
            font-weight: 650;
            font-style: normal;
            font-size: 22px;
            margin-top: 10px;
          }

          .painpoint-text {
            font-family: 'PingFang-SC-ExtraLight', 'PingFang SC ExtraLight',
              'PingFang SC', sans-serif;
            font-weight: 400;
            font-style: normal;
            font-size: 14px;
            line-height: 30px;
            margin-top: 10px;
          }

          .iconlogo {
            width: 61px;
            height: 61px;
            // background: url('../../../../assets/img/childrenpage/smartPublicSecurity/iconbg1.svg');
            // background-size: 100% 100%;
            // background-repeat: no-repeat;
            text-align: center;
            line-height: 80px;

            .neicon {
              width: 61px;
              height: 61px;
            }
          }
        }
      }
    }
  }

  /* 核心价值 */
  .coreValues {
    width: 100vw;
    height: 100vh;
    background: url('../../../../assets/img/childrenpage/smartPublicSecurity/corebg.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .coreValues-content {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      flex-direction: column;
      top: 10vh;

      .coreValues-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        width: 100vw;
        min-height: 30vh;
        // margin-top: 2vh;

        .valueModel1 {
          width: 1203px !important;
          height: 406px !important;
          position: relative;
          top: 60px;
        }

        .valueModel2 {
          width: 1203px !important;
          height: 306px !important;
          position: relative;
          top: 10px;
        }

        .valueModel3 {
          width: 1203px !important;
          height: 206px !important;
        }

        .valueModel4 {
          width: 800px !important;
          height: 306px !important;
          position: relative;
          top: 10px;
        }

        .valueModel5 {
          width: 800px !important;
          height: 206px !important;
        }

        .sizewidthitem {
          width: 893px !important;
          height: 206px;
        }

        .coreValues-item {
          height: 206px;
          width: 663px;
          background: #ffffff60;
          // background: url('../../../../assets/img/childrenpage/smartPublicSecurity/coreitem.svg');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          display: flex;
          align-items: center;
          margin-top: 4vh;
          margin-left: 20px;
          margin-right: 20px;
          padding-right: 30px;

          .itemicon {
            width: 172px;
            height: 156px;
            margin-left: 30px;
            border-radius: 10px;
          }

          .coreValues-right {
            margin-left: 30px;

            // height: 60%;
            .coreValues-title {
              font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold',
                'PingFang SC ExtraLight', 'PingFang SC', sans-serif;
              font-weight: 650;
              font-style: normal;
              font-size: 22px;
            }

            .coreValues-text {
              font-family: 'PingFang-SC-ExtraLight', 'PingFang SC ExtraLight',
                'PingFang SC', sans-serif;
              font-weight: 400;
              font-style: normal;
              font-size: 14px;
              line-height: 30px;
              height: 120px !important;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 4;
              overflow: hidden;
              margin-top: 10px;
            }
          }
        }
      }
    }
  }

  /* 特色应用 */
  .featureapplication {
    width: 100vw;
    // height: 100vh;
    background: url('../../../../assets/img/childrenpage/smartPublicSecurity/planbg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .featureapplication-content {
      width: 100%;
      height: 100%;
      display: flex;
      // justify-content: center;
      align-items: center;
      background: rgba($color: #ffffff, $alpha: 0.9);
      background-size: 100% 100%;
      position: relative;
      flex-direction: column;

      padding-top: 80px;

      .featureapplication-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 2vh;
        width: 92vw;
        min-height: 20vh;
        height: 80vh;
        // overflow: scroll;
        // padding: 0 10vw;

        // padding: 0 5%;
        .valueModel1 {
          width: 1503px !important;
          position: relative;
          // top: 120px;
          top: 0px;

          .featureapplication-right {
            .itemicon {
              width: 1000px;
              height: auto;
            }
          }

          // height: 606px !important;
        }

        .valueModel2 {
          width: 1503px !important;

          // height: 256px !important;
          .featureapplication-text {
            height: 90px !important;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
          }
          .featureapplication-right {
            .itemicon {
              width: 1000px;
              height: auto;
            }
          }
        }

        .valueModel3 {
          width: 450px !important;
          // height: 206px !important;
          height: 806px !important;
          position: relative;
          top: 60px;

          .featureapplication-text {
            height: 386px !important;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 13;
            overflow: hidden;
          }
        }

        .valueModel4 {
          width: 700px !important;

          height: 346px !important;

          .featureapplication-text {
            height: 90px !important;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
          }
        }

        .valueModel5 {
          width: 450px !important;
          height: 346px !important;

          .featureapplication-text {
            height: 90px !important;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
          }
        }

        .sizewidthitem {
          width: 893px !important;
          height: 206px;
        }

        .featureapplication-item {
          width: 370px;
          min-height: 206px;

          display: flex;
          align-items: center;
          margin-left: 50px;
          margin-right: 50px;
          margin-top: 20px;

          .itemicon {
            // padding-top: 10px;
            width: 360px;
            height: 205px;
            margin-bottom: 10px;
            border-radius: 10px;

            // margin-left: 30px;
          }

          .featureapplication-right {
            // width: 540px;
            width: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center; // margin-left: 30px;

            .featureapplication-title {
              font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold',
                'PingFang SC ExtraLight', 'PingFang SC', sans-serif;
              font-weight: 650;
              font-style: normal;
              margin-top: 12px;
              font-size: 22px;
            }

            .featureapplication-text {
              font-family: 'PingFang-SC-ExtraLight', 'PingFang SC ExtraLight',
                'PingFang SC', sans-serif;
              font-weight: 400;
              font-style: normal;
              font-size: 14px;
              line-height: 30px;
              margin-top: 10px;
              overflow: hidden;
            }

            // width: 408px;
          }
        }
      }
    }
  }
}

.bannerchange {
  // background: rgba(47, 147, 247, 0.8);
  position: absolute;
  // top: 60px;
  width: 100%;
  height: calc(22vh + 2px);
}

.topbanner {
  margin-top: 60px;
}

.titlefont {
  font-size: 60px;
  font-weight: bold;
}

.sendStyle {
  color: white;
  font-size: 20px;
  background-color: #3564f2;
  border-radius: 60px;
  border: none;
  width: 150px;
  height: 60px;
  cursor: pointer;
}

// .swiper-slide {
//   z-index: 2000;
// }</style>

<style lang="scss">
.demo-ruleForm {
  .el-input-group__append {
    background-color: #409EFF;
    color: #fff;
    cursor: pointer;

  }
}
</style>